import React from 'react';
import styled from 'styled-components';
import { StyledAvatar } from '../../../../components/atoms/Avatar';
import { Resident } from '../../../../components/molecules/CascadedAvatars';
import defaultAvatar from 'images/avatar.svg';

/**
 * TODO: Hidden (display: none) until the social proof feature is defined and implemented.
 * Product has requested we remove it temporarily until it is ready.
 **/
const StyledBanner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 1rem;
  border-top: 1px solid #e6e6e6;
  display: none;
`;

const StyledRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const StyledCount = styled.span`
  font-size: 2rem;
  font-weight: 600;
  color: #232323;
`;

const StyledPeople = styled.span`
  font-size: 1.25rem;
  font-weight: 600;
  color: #232323;
`;

const StyledAvatarStack = styled.div`
  display: flex;
  align-items: center;
  margin-left: 0.25rem;
`;

const SizedAvatar = styled(StyledAvatar)`
  && {
    border: 2px solid #ffffff;
  }
  display: block;
  margin-left: -0.5rem;

  &:first-child {
    margin-left: 0;
  }

  &:hover {
    border: 2px solid #ffffff;
    outline: none;
  }
`;

const StyledSub = styled.span`
  font-size: 0.875rem;
  color: #57534e;
`;

type Props = {
  count: number;
  residents: Resident[];
  listingName: string;
};

export function SocialProofBanner({
  count,
  residents,
  listingName,
}: Readonly<Props>) {
  if (residents.length <= 0) return null;

  const visible = residents.slice(0, 4);

  return (
    <StyledBanner>
      <StyledRow>
        <StyledCount>{count}</StyledCount>
        <StyledPeople>people</StyledPeople>
        <StyledAvatarStack>
          {visible.map((r) => (
            <SizedAvatar
              key={r.id}
              alt={r.first_name}
              round
              src={r.image_url || defaultAvatar}
              size={2}
            />
          ))}
        </StyledAvatarStack>
      </StyledRow>
      <StyledSub>
        recently messaged with verified residents at {listingName}
      </StyledSub>
    </StyledBanner>
  );
}
